import { Grid } from "@mui/material";
import React from "react";
import "./footer.css";

function Footer() {
  const footerData = [
    {
      des: "all NFTs",
    },
    {
      des: "music",
    },
    {
      des: "games",
    },
    {
      des: "art",
    },
    {
      des: "photography",
    },
  ];
  const footerDataTwo = [
    {
      des: "profile",
    },
    {
      des: "Favorites      ",
    },
    {
      des: "watchlist",
    },
    {
      des: "my collection",
    },
    {
      des: "settings",
    },
  ];
  const footerDataThree = [
    {
      des: "ranking",
    },
    {
      des: "activity      ",
    },
  ];
  const footerDataFour = [
    {
      des: "help center",
    },
    {
      des: "platform status",
    },
    {
      des: "partners",
    },
    {
      des: "blogs",
    },
    {
      des: "docs",
    },
    {
      des: "newsletter",
    },
  ];
  const footerDataFive = [
    {
      des: "about",
    },
    {
      des: "career",
    },
    {
      des: "ventures",
    },
    {
      des: "grants",
    },
  ];
  return (
    <div className="footer_div">
      <Grid container justifyContent="center">
        <Grid item xs={11} md={10}>
          <Grid container justifyContent="center" flexWrap="wrap">
            <Grid item xs={6} lg={2}>
              <h1 className="footer_links">Marketplace</h1>
              <ul className="footer_ul">
                {footerData.map((e) => {
                  return (
                    <li className="footer_li">
                      <a href="#" className="footer_links_a">
                        {e.des}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </Grid>
            <Grid item xs={6} lg={2}>
              <h1 className="footer_links">my account</h1>
              <ul className="footer_ul">
                {footerDataTwo.map((e) => {
                  return (
                    <li className="footer_li">
                      <a href="#" className="footer_links_a">
                        {e.des}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </Grid>
            <Grid item xs={6} lg={2}>
              <h1 className="footer_links">stats</h1>
              <ul className="footer_ul">
                {footerDataThree.map((e) => {
                  return (
                    <li className="footer_li">
                      <a href="#" className="footer_links_a">
                        {e.des}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </Grid>
            <Grid item xs={6} lg={2}>
              <h1 className="footer_links">resources</h1>
              <ul className="footer_ul">
                {footerDataFour.map((e) => {
                  return (
                    <li className="footer_li">
                      <a href="#" className="footer_links_a">
                        {e.des}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </Grid>
            <Grid item xs={6} lg={2}>
              <h1 className="footer_links">company</h1>
              <ul className="footer_ul">
                {footerDataFive.map((e) => {
                  return (
                    <li className="footer_li">
                      <a href="#" className="footer_links_a">
                        {e.des}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

export default Footer;
